export default "__VITE_ASSET__DPGXAh7R__"